import {Injectable} from '@angular/core';
import * as actions from '../usuario-certificado-store/usuario-certificado.actions';
import {Store} from "@ngxs/store";
import { EnumTipoAutenticacaoEnvioPortalUnico } from "@catalogo/features/operacional/enums/enum-entities";

@Injectable({ providedIn: 'root' })
export class UsuarioCertificadoModalSenhaService {

    constructor(
        private store: Store
    ) { }

    public confirmar = (senha: string, logar: boolean, tipoAutenticacao: EnumTipoAutenticacaoEnvioPortalUnico) => {
        if(!tipoAutenticacao){
            tipoAutenticacao = EnumTipoAutenticacaoEnvioPortalUnico.Usuario;
        }
        this.store.dispatch(new actions.FecharModalSenha({validar: true, senha, logar, tipoAutenticacao: tipoAutenticacao}));
    };

    public fechar = () => this.store.dispatch(new actions.FecharModalSenha({ validar: false }));

}
